import React from 'react';
import Img from '../../Img';

import styles from './ptswidget.module.scss';

const PtsWidget = props => {
    return (
        <React.Fragment>
            <div className={styles.widgetImageWrapper}>
                <Img
                    src="/img/pts_dark_v3.png"
                    srcSet={`/img/pts_dark_v3@2x.png 2x, /img/pts_dark_v3@3x.png 3x`}
                />
            </div>
            <div className={`${styles.iframeWrapper}`}>
                <iframe className={styles.widgetFrame} frameBorder="0" height="450px" width="100%" src={`${props.widgetLink}`} title="UTR-Pro-Tennis-Series" />
            </div>
            <div className={`${styles.widgetDisclaimer} text-center d-flex justify-content-center`}>
                <div>
                    Enable third party cookies to view live scores
                </div>
            </div>
        </React.Fragment>
    );
};


export default PtsWidget;
